import { RootState } from "../root.reducer";
import { ISelectedItinerary } from "./selectedItinerary.slice";

export const selectedItinerarySelector = (state: RootState) =>
  state.selectedItinerary;

export const itinerarySelector = (state: RootState) => {
  const { includesBrandedFares, itineraries, indexOfRequestedItinerary } =
    state.selectedItinerary;

  const itinerary = includesBrandedFares
    ? itineraries[indexOfRequestedItinerary]
    : itineraries[0];
  return itinerary;
};
